import React, { Component } from 'react';
import WalletInformation from './WalletInformation';
import MyTransactions from './MyTransactions';
import MyCoinsMinted from './MyCoinsMinted';
import AsyncCoinContractABI from '../../../build/contracts/AsyncCoin';
import AddressName from '../Components/AddressName';
import { ASYNC_NETWORK_ID } from '../../utils/Constants';
import Newsletter from './Newsletter';

export default class HomePage extends Component {
  constructor (props) {
    super(props);
    this.state = {
      contractAddress: AsyncCoinContractABI.networks[ASYNC_NETWORK_ID].address
    };
  }

  render () {
    return (
      <div className="c-home-page">
        <h1>AsyncCoin</h1>
        <div className="c-components">
          <WalletInformation/>
          <div className="c-component">
            <h2>What is AsyncCoin?</h2>
            <p>
              AsyncCoinDashboard is example DAPP.<br/>
              To use it you need <a href="https://metamask.io" target="_blank">MetaMask</a>.<br/>
              AsyncCoin works on Ropsten test network.
            </p>
            <div>
              Contract address:
              <AddressName address={this.state.contractAddress}/>
            </div>
          </div>
          <Newsletter/>
        </div>
        <div className="c-components">
          <MyTransactions/>
          <MyCoinsMinted/>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js